import config from '~/config';

export const formatHumanDateTime = (
	date: Date,
	locale: string[] = config.locale,
	month: 'numeric' | '2-digit' | 'long' | 'short' | 'narrow' = 'long'
) =>
	Intl.DateTimeFormat(locale, {
		hour: 'numeric',
		minute: 'numeric',
		day: 'numeric',
		month,
		year: 'numeric',
	})
		.format(date)
		.replace(/ /g, '\xA0');
